import store from 'store/index';
import {requestPayload} from 'store/modules/claim';
import {previousValid} from 'store/generators/step';
import Validator from 'services/Validator';
import Api from "services/Api";

export const mutationTypes = {
    RESET: 'RESET',
};

/**
 * Root Validation Rules.
 *
 * This isn't permanent, I think we should make this supported by the normal
 * rules as it allows us to validate a step for data which isn't necessarily
 * stored on that step (but could be input there).
 *
 * @type {Object}
 */
const rootRules = {
     'personal.claimant.theClaimant.income.pastLossOfEarnings': {type: 'text', rules: 'required'},
};

// Initial State
const state = {

};

// Getters
const getters = {

};

// Actions
const actions = {
    /**
     * Save the step by submitting to the server.
     */
    save({getters, dispatch, rootState, state}, payload) {
        payload.data = state;
        payload.data.retirement_date = rootState.personal.claimant.theClaimant.income.retirementDate;
        payload.data.assumed_date_of_death = rootState.personal.claimant.theClaimant.assumedLifeExpectancy.dateOfDeath;

        Api.claims.save(payload).then((response) => {
            return response;
        });

        // Api.claims.save(payload).then((response) => {
        //     return response;
        // });

        // Now Update the first step, since that is where we store the claimaint info
        // This isn't nice but it will have to do for now...
        store.dispatch('personal/save', requestPayload(0));
    },
    /**
     * Loads the step being received from the Server, to be placed in the state.
     */
    load({ dispatch, action, commit }, step) {
        // Nothing to do here.
    },
    /**
     * Performs any processing once the data from the server has been stored.
     * This is a good place to do calculations or dispatch other actions which
     * are used to refresh/update calculated data on other steps/components.
     */
    process({ commit, dispatch }) {
        store.dispatch('personal/step/setStepNumberValid', {
            stepNo: 2,
            valid: true, // needs updating with real validity
        });
    },
    /**
     * Validate the step.
     *
     * @param commit
     */
    validate({ commit, rootState }) {
        store.dispatch('personal/step/setStepNumberValid', {
            stepNo: 2,
            valid: previousValid(rootState, 2)
            && (new Validator(rootState, rootRules)).validate(),
        });
    },
    /**
     * Resets the step back to defaults
     */
    reset({ commit }) {
        store.dispatch('personal/step/setStepNumberValid', {
            stepNo: 2,
            valid: false,
        });
        
        commit(mutationTypes.RESET);
    },
};

// Mutations
const mutations = {
    [mutationTypes.RESET](state) {

    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/personal/pastLossOfEarnings.js